import React from 'react';
import { Container, Row, Col, Input, Label, Button } from 'reactstrap';
import CustomDropDownView from "./CustomDropDownView"

class AddDropDownView extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            'typeId': '',
            'seemore': {},
        }
    }

    render() {
        if (this.props.sign.type.id !== this.state.typeId) {
            this.setState({
                'typeId': this.props.sign.type.id,
                'seemore': [],
            })
        }

        let addons = []
        if (this.props.addons) {
            addons = this.props.addons
        }

        const createSubView = (name, addons, row_index) => {

            let adds = addons.map((add, index) => {
                if (add.square_inch_price === 0 && add.unit_price === 0) {
                    return <Row key={"row"+row_index+'-'+index}>
                        <Col>
                            <Label style={{'marginLeft': '8px'}}>{add.label}</Label>
                        </Col>
                    </Row>
                }
                else {
                    return <Row key={"row"+row_index+'-'+index}>
                        <Col>
                            <Input
                                defaultChecked={this.props.sign.hasAddon(add)}
                                type="checkbox" onClick={(e) => this.props.onChange(add)}/>
                            <Label style={{'marginLeft': '8px'}}>{add.label}</Label>
                        </Col>
                    </Row>
                }
            })

            const addsLength = adds.length

            if (!(name in this.state.seemore)) {
                adds = adds.slice(0, 5)
            }

            return <>
                <Label key={'label' + row_index} style={{
                    'fontWeight': '450',
                }}>{name}</Label>
                <Container key={'container'+row_index}>
                    {adds}
                    { (name in this.state.seemore) || addsLength <= 5 ? <></> :
                    <Row><Col>
                        <Button color="link"
                            onClick={(e) => {
                                const seemore = this.state.seemore
                                seemore[name] = true
                                this.setState({
                                    'seemore': seemore,
                                })
                            }}>See More</Button>
                    </Col></Row>
                    }
                </Container>
            </>
        }

        const createView = () => {

            const options = {}
            const names = []
            for (let i = 0; i < addons.length; i++) {
                if (!(addons[i].cost_label in options)) {
                    options[addons[i].cost_label] = []
                    names.push(this.props.addons[i].cost_label)
                }

                options[addons[i].cost_label].push(addons[i])
            }

            const view = names.map((name, index) =>
                <div key={'div' + index}>
                    {createSubView(name, options[name], index)}
                </div>
            )

            return <Container >
                <Row key={'row0'}>
                    <Col>
                        <Label style={{
                            'fontSize': '18px',
                            'fontWeight': '500',
                        }}>{this.props.sign.type.label}</Label>
                    </Col>
                </Row>
                <Row key={"row1"}>
                    <Col>
                        <Container key={'main'}>{view}</Container>
                    </Col>
                </Row>
            </Container>
        }

        return (
            <CustomDropDownView
               name="Adds" view={createView()} />
        )
    }
}

export default AddDropDownView
